import React from 'react';
import './OrderHistoryPage.scss';
import { Icon } from 'antd';
import Button from 'Components/Shared/Button/Button';
import Spinner from 'Components/Shared/Spinner/Spinner';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import OrderHistoryItem from 'Pages/OrderHistoryPage/OrderHistoryItem/OrderHistoryItem';

interface IProps {
  isLoggedIn: boolean;
  isFetching: boolean;
  orderHistory: Julius.Website.OrderSmallViewModel[];
  onBack: () => void;
  onQuestions: () => void;
}

const OrderHistoryPage: React.SFC<IProps> = ({ 
  isLoggedIn,
  isFetching,
  orderHistory,
  onBack,
  onQuestions,
}) => {

  const HeaderText = () => (
    <FormattedText 
      style='header'
      displayName='Mina bokningar'
      formattedName='user.mytickets'
    />
  );

  const NavButtons = () => (
    <div className='button-container'>
      <Button style='button-start' color='transparent' onClick={ onBack }>
        <Icon type='arrow-left' />
        <FormattedText
          displayName='Till startsidan'
          formattedName='global.backtostart'
        />
      </Button>
      <Button style='button-faq' color='transparent' onClick={ onQuestions }>
        <FormattedText
          displayName='Frågor och svar'
          formattedName='menu.faq'
        />
        <Icon type='arrow-right' />
      </Button>
    </div>
  );

  if (isFetching) {
    return (
      <WrapperLayout style='order-history-page'>
        <NavButtons />
        <HeaderText />
        <Spinner height='lg' />
      </WrapperLayout>
    ); 
  }

  if (!isLoggedIn) {
    return (
      <WrapperLayout style='order-history-page'>
        <NavButtons />
        <HeaderText />
        <FormattedText 
          style='speech-bubble'
          displayName='Logga in för att se dina bokningar'
          formattedName='user.loginfortickets'
        />
      </WrapperLayout>
    ); 
  }

  if (!orderHistory || !orderHistory.length) {
    return (
      <WrapperLayout style='order-history-page'>
        <NavButtons />
        <HeaderText />
        <FormattedText 
          style='speech-bubble'
          displayName='Ops! Här finns inga bokningar än.'
          formattedName='user.tickets.empty'
        />
      </WrapperLayout>
    ); 
  }

  return (
    <WrapperLayout style='order-history-page'>
      <NavButtons />
      <HeaderText />
      { orderHistory.map(o =>
        <OrderHistoryItem key={ o.orderID } orderHistoryItem={ o } />)
      }
    </WrapperLayout>
  );
}

export default OrderHistoryPage;


// WEBPACK FOOTER //
// ./src/pages/OrderHistoryPage/OrderHistoryPage.tsx